import { CacheKeys } from 'cache-keys-enum';
import { ApiRoute } from 'enums';

import { useQuery } from 'react-query';
import { ArchivalAidMetadata } from 'types';
import fetch from 'utils/fetch';

export const useArchivalAidDetail = (aidId?: string) =>
  useQuery(
    [CacheKeys.ARCHIVAL_AID, aidId],
    () =>
      fetch(`/api/${ApiRoute.ARCHIVAL_AID}/${aidId}`).then(
        async (r) => (await r.json()) as ArchivalAidMetadata
      ),
    { enabled: !!aidId }
  );
